import { colors } from '@lmc/common/constants'
import type { ReactNode } from 'react'
import styled from 'styled-components'

interface StyledDotProps {
  $active?: boolean
  $color: string
  $fontSize: number
  $margin: string
  $selectable?: boolean
  $size: number
}

const StyledDot = styled.div<StyledDotProps>`
  background-color: ${({ $active, $color }) => ($active ? $color : colors.grey)};
  border-radius: 50%;
  color: white;
  display: inline-block;
  font-size: ${({ $fontSize }) => $fontSize}px;
  height: ${({ $size }) => $size}px;
  margin: ${({ $margin }) => $margin};
  padding-top: ${({ $size }) => Math.floor($size / 5)}px;
  text-align: center;
  width: ${({ $size }) => $size}px;
  ${({ $selectable }) => $selectable && '&:hover { cursor: pointer; }'}
`

interface DotProps {
  active?: boolean
  color?: string
  fontSize?: number
  label?: ReactNode
  margin?: string
  onSelect?: () => void
  selectable?: boolean
  size?: number
}

export default function Dot({
  active,
  color = colors.green,
  fontSize = 12,
  label,
  margin = '0 8px',
  onSelect,
  selectable,
  size = 24
}: DotProps) {
  return (
    <StyledDot
      $active={active}
      $color={color}
      $fontSize={fontSize}
      $margin={margin}
      $selectable={selectable}
      $size={size}
      onClick={() => onSelect?.()}
    >
      {label}
    </StyledDot>
  )
}
